/**
 * Build a human-readable label for a connected molecular component.
 *
 * Examples:
 *   nameMolecule(1, 0, 0)   → "Molecule 1: single atom"
 *   nameMolecule(12, 11, 0) → "Molecule 1: 12 atoms, 11 bonds"
 *
 * @param atomCount Number of atoms in the molecule
 * @param bondCount Number of bonds in the molecule
 * @param index     0-based ordinal of this molecule within the workspace
 *                  (the label uses 1-based numbering)
 */
export function nameMolecule(
    atomCount: number,
    bondCount: number,
    index: number,
): string {
    if (atomCount === 1) {
        return `Molecule ${index + 1}: single atom`;
    }
    return `Molecule ${index + 1}: ${atomCount} atoms, ${bondCount} bonds`;
}
